<template>
  <div>
    <b-checkbox v-model="isRegulationBAccepted" :class="{'animate__animated': true, 'animate__shakeX': isError}">
      I agree to <a href="#" @click="showRegulationBModal(true)">regulation b</a>
    </b-checkbox>
    <portal to="global-modal-portal" v-if="isRegulationBModalActive">
      <b-modal :active.sync="isRegulationBModalActive" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Regulation B</p>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column has-text-left">
                <p>For a complete review of Regulation B please review the following online link <br><br>
                  <a href='https://www.investopedia.com/terms/r/regulation-b.asp' target='_blank'>Investopedia - Regulation B</a>
                  <br><br> By clicking 'Accept/Submit', you confirm an understanding of Regulation B and agree to its described mandates.</p>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-info" @click="showRegulationBModal(false)">Accept</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>

export default {
  name: 'RegulationBControl',
  components: {
  },
  props: {
    currentCustomer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isRegulationBModalActive: false,
      instanceId: this.$uuid.v4(),
      isError: false
    }
  },
  computed: {
    // Bound directly to the prop so the checkbox cannot desync
    // when the parent reassigns currentCustomer.
    isRegulationBAccepted: {
      get () {
        return this.currentCustomer ? !!this.currentCustomer.regulationB : false
      },
      set (value) {
        if (this.currentCustomer) {
          this.currentCustomer.regulationB = value
        }
      }
    }
  },
  methods: {
    showError: function () {
      this.$buefy.toast.open(
        {
          duration: 2500,
          message: 'You must accept the Regulation B terms to proceed',
          position: 'is-top',
          type: 'is-warning'
        })
      this.isError = true
      window.setTimeout(() => {
        this.isError = false
      }, 1000)
    },
    showRegulationBModal: function (state) {
      if (state) {
        this.isRegulationBModalActive = true
      } else {
        this.isRegulationBModalActive = false
      }
    }
  },
  mounted: function () {
  }
}

</script>

<style scoped>
  .modal-card-head, .modal-card-foot {
    padding: 20px !important
  }

  .modal-card-body {
    max-height: 500px !important;
    min-height: 500px !important;
    height: 500px !important;
  }
</style>
